// import React from "react";

// function CartItemsinCheckout({ item }) {
//   const image = item.thumbnail;
//   const title = item.title;
//   const variantName = item.variantName;
//   const quantity = item.quantity;
//   const mrp = item.mrp;
//   const subtotal = item.subtotal;

//   const price = item?.price.toFixed(2);

//   return (
//     <li className="order-item">
//       <figure className="img-product">
//         <img src={image} alt="product" />
//       </figure>
//       <div className="content">
//         <div className="info">
//           <p className="name text-sm fw-medium">{title}</p>
//           <span className="variant">{variantName}</span>
//           {/* <span className="variant">
//             Qty: <b>{quantity}</b>
//           </span> */}
//         </div>
//         <span className="price text-sm fw-medium text-end">
//           {/* <span className="price text-sm fw-medium">₹{price}/-</span> */}

//           {!isNaN(mrp) && mrp > price && (
//             <span className="text-decoration-line-through text-dark-1">
//               ₹{mrp.toFixed(2)}/-
//             </span>
//           )}<br/>

//           <span className="price text-sm fw-medium">₹{subtotal}/-</span>
//         </span>
//       </div>
//     </li>
//   );
// }

// export default CartItemsinCheckout;







import React from "react";

function CartItemsinCheckout({ item }) {
  const image = item.thumbnail;
  const title = item.title;
  const variantName = item.variantName;
  const quantity = item.quantity;
  const mrp = item.mrp;
  const subtotal = item.subtotal;
  const price = item?.price.toFixed(2);

  return (
    <li className="flex items-center space-x-4 py-3">
      <figure className="w-16 h-16 flex-shrink-0 bg-gray-100 rounded-lg overflow-hidden border border-gray-200">
        <img src={image} alt="product" className="w-full h-full object-cover" />
      </figure>
      
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-gray-900 truncate">{title}</p>
        <span className="text-xs text-gray-500 block mt-0.5">{variantName}</span>
      </div>

      <div className="text-right flex-shrink-0">
        {!isNaN(mrp) && mrp > price && (
          <span className="text-xs text-gray-400 line-through block">
            ₹{mrp.toFixed(2)}/-
          </span>
        )}
        <span className="text-sm font-semibold text-gray-900">₹{subtotal}/-</span>
      </div>
    </li>
  );
}

export default CartItemsinCheckout;

